module.exports = __webpack_public_path__ + "img/map_rocking-chairs.dce694e1.jpg";